module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_12-bade970b5095ce682f1b3935ed584a0a.jpg";